import React, { useEffect, useRef, useState } from 'react';
import { storageImage } from '../../../../lib/img';

const NICHE_OPTIONS = [
  'Mental Health', 'Self-Help', 'Business', 'Entrepreneurship', 'Health & Fitness',
  'True Crime', 'Comedy', 'Technology', 'Education', 'Finance', 'Parenting',
  'Spirituality', 'Relationships', 'Sports', 'Music', 'News & Politics',
  'Science', 'Culture & Society', 'Gaming', 'Other',
];

const SOCIALS = [
  { id: 'spotify',    placeholder: 'https://open.spotify.com/your-profile',     Icon: SpotifyIcon },
  { id: 'instagram',  placeholder: 'https://www.instagram.com/your-profile',    Icon: InstagramIcon },
  { id: 'tiktok',     placeholder: 'https://www.tiktok.com/@your-profile',      Icon: TikTokIcon },
  { id: 'soundcloud', placeholder: 'https://soundcloud.com/your-profile',       Icon: SoundCloudIcon },
  { id: 'youtube',    placeholder: 'https://www.youtube.com/your-profile',      Icon: YouTubeIcon },
  { id: 'x',          placeholder: 'https://x.com/your-profile',                Icon: XIcon },
];

function SpotifyIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm5.7 17.2a.75.75 0 0 1-1 .25c-2.8-1.7-6.3-2-10.4-1.1a.75.75 0 0 1-.3-1.5c4.5-1 8.3-.6 11.4 1.3.4.2.5.6.3 1zm1.5-3.3a.9.9 0 0 1-1.2.3c-3.2-2-8-2.5-11.8-1.4a.9.9 0 0 1-.5-1.8c4.3-1.3 9.7-.7 13.3 1.6.4.3.5.9.2 1.3zm.1-3.4C15.5 8 8.8 7.8 5.4 8.9a1.1 1.1 0 1 1-.7-2.2c4-1.2 11.3-1 15.4 1.5a1.1 1.1 0 0 1-1.2 1.9z"/></svg>; }
function InstagramIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>; }
function TikTokIcon()    { return <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.6 6.3a6 6 0 0 1-3.5-1.1v9.4a5.6 5.6 0 1 1-5.6-5.6 5.7 5.7 0 0 1 1 .1v2.6a3 3 0 1 0 2 2.8V2h2.6a4 4 0 0 0 3.5 4z"/></svg>; }
function SoundCloudIcon(){ return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 17v-4M5 19v-8M8 19v-10M11 19v-12M14 19V7a5 5 0 0 1 10 0v9a3 3 0 0 1-3 3H14"/></svg>; }
function YouTubeIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4L15.8 12z"/></svg>; }
function XIcon()         { return <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>; }

const PROFILE_KEY = 'episode_profile_edit';

function loadEdit() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return null;
}
function saveEdit(state) {
  try { localStorage.setItem(PROFILE_KEY, JSON.stringify(state)); } catch {}
}

export default function EditProfileModal({ open, onClose, user, profile }) {
  const initials = (profile?.full_name?.[0] || user?.email?.[0] || '?').toUpperCase();
  const [state, setState] = useState(() => {
    const saved = loadEdit();
    return {
      bgImage:     saved?.bgImage     || '',
      avatar:      saved?.avatar      || profile?.avatar_url || '',
      displayName: saved?.displayName || profile?.full_name || '',
      bio:         saved?.bio         || '',
      handle:      saved?.handle      || `@${(user?.email || '').split('@')[0]}`,
      genres:      saved?.genres      || [],
      socials:     saved?.socials     || {},
    };
  });
  const [savedFlash, setSavedFlash] = useState(false);
  const [genreInput, setGenreInput] = useState('');
  const bgRef = useRef(null);
  const avRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose?.(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  function pickFile(ref, key) {
    ref.current?.click();
  }
  function onFile(e, key) {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = ev => setState(s => ({ ...s, [key]: ev.target.result }));
    reader.readAsDataURL(f);
  }

  function addGenre(g) {
    const val = (g || genreInput).trim();
    if (!val) return;
    if (state.genres.length >= 5) return;
    if (state.genres.includes(val)) { setGenreInput(''); return; }
    setState(s => ({ ...s, genres: [...s.genres, val] }));
    setGenreInput('');
  }
  function removeGenre(g) {
    setState(s => ({ ...s, genres: s.genres.filter(x => x !== g) }));
  }

  function updateSocial(id, value) {
    setState(s => ({ ...s, socials: { ...s.socials, [id]: value } }));
  }

  function handleSave() {
    saveEdit(state);
    setSavedFlash(true);
    setTimeout(() => { setSavedFlash(false); onClose?.(); }, 700);
  }

  const bioLen = state.bio.length;
  const BIO_MAX = 1200;

  return (
    <div className="v4-ep-wrap" role="dialog" aria-modal="true" aria-label="Edit profile">
      <div className="v4-ep-backdrop" onClick={onClose} />
      <div className="v4-ep">
        <header className="v4-ep-head">
          <div className="v4-ep-title">Edit Profile</div>
          <button className="v4-ep-close" onClick={onClose} aria-label="Close">✕</button>
        </header>

        <div className="v4-ep-body">
          {/* Background image */}
          <label className="v4-ep-label">
            Background image
            <span className="v4-ep-hint" title="Shown behind your public profile">ⓘ</span>
          </label>
          <button className="v4-ep-bg-drop" onClick={() => pickFile(bgRef)}>
            {state.bgImage ? (
              <>
                <img src={storageImage(state.bgImage, { width: 900 })} alt="" className="v4-ep-bg-img" />
                <span className="v4-ep-bg-edit">✎</span>
              </>
            ) : (
              <div className="v4-ep-bg-empty">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                <span>Upload a photo</span>
              </div>
            )}
          </button>
          <input ref={bgRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => onFile(e, 'bgImage')} />

          {/* Profile picture */}
          <label className="v4-ep-label">
            Profile picture
            <span className="v4-ep-hint" title="Shown everywhere in the app">ⓘ</span>
          </label>
          <button className="v4-ep-pp-drop" onClick={() => pickFile(avRef)}>
            {state.avatar
              ? <img src={storageImage(state.avatar, { width: 360 })} alt="" className="v4-ep-pp-img" />
              : (
                <div className="v4-ep-pp-empty">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </div>
              )}
            <span className="v4-ep-pp-edit">✎</span>
          </button>
          <input ref={avRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => onFile(e, 'avatar')} />

          {/* Display name */}
          <label className="v4-ep-label">Display Name</label>
          <input
            className="v4-ep-input"
            value={state.displayName}
            onChange={e => setState(s => ({ ...s, displayName: e.target.value }))}
            placeholder={initials}
          />

          {/* Bio */}
          <label className="v4-ep-label">Add a bio</label>
          <div className="v4-ep-ta-wrap">
            <textarea
              className="v4-ep-ta"
              value={state.bio}
              onChange={e => setState(s => ({ ...s, bio: e.target.value.slice(0, BIO_MAX) }))}
              placeholder="Tell us about yourself..."
            />
            <span className="v4-ep-count">{bioLen}/{BIO_MAX}</span>
          </div>

          {/* Handle */}
          <label className="v4-ep-label">Handle<span className="v4-ep-req">*</span></label>
          <input
            className="v4-ep-input"
            value={state.handle}
            onChange={e => {
              let v = e.target.value;
              if (!v.startsWith('@')) v = '@' + v.replace(/^@+/, '');
              setState(s => ({ ...s, handle: v }));
            }}
            placeholder="@yourhandle"
          />

          {/* Niche / Genres override */}
          <label className="v4-ep-label">Niche Override</label>
          <div className="v4-ep-sub">
            Add up to 5 niches to describe your podcast style. If empty, we'll infer from your most
            popular episodes.
          </div>
          <div className="v4-ep-chip-row">
            {state.genres.map(g => (
              <span key={g} className="v4-ep-chip">
                {g}
                <button onClick={() => removeGenre(g)} aria-label={`Remove ${g}`}>✕</button>
              </span>
            ))}
          </div>
          <div className="v4-ep-genre-row">
            <input
              className="v4-ep-input v4-ep-input-flex"
              list="v4-ep-niche-options"
              value={genreInput}
              onChange={e => setGenreInput(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addGenre(); } }}
              placeholder="Type a niche..."
              disabled={state.genres.length >= 5}
            />
            <span className="v4-ep-count">{state.genres.length}/5</span>
            <button
              className="v4-ep-add"
              onClick={() => addGenre()}
              disabled={state.genres.length >= 5 || !genreInput.trim()}
            >Add</button>
          </div>
          <datalist id="v4-ep-niche-options">
            {NICHE_OPTIONS.map(n => <option key={n} value={n} />)}
          </datalist>

          {/* Socials */}
          <label className="v4-ep-label">Social networks</label>
          <div className="v4-ep-socials">
            {SOCIALS.map(s => (
              <div key={s.id} className="v4-ep-social-row">
                <span className="v4-ep-social-icon"><s.Icon /></span>
                <input
                  className="v4-ep-input v4-ep-social-input"
                  value={state.socials[s.id] || ''}
                  onChange={e => updateSocial(s.id, e.target.value)}
                  placeholder={s.placeholder}
                />
              </div>
            ))}
          </div>
        </div>

        <footer className="v4-ep-actions">
          <button className="v4-ep-cancel" onClick={onClose}>Cancel</button>
          <button className="v4-ep-save" onClick={handleSave}>
            {savedFlash ? 'Saved ✓' : 'Save'}
          </button>
        </footer>
      </div>
    </div>
  );
}
